var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.loggedIn && !_vm.routeWithoutToolbar)?_c('ToolBar'):_vm._e(),_c('div',{class:_vm.loggedIn ? 'app-container' : ''},[_c('v-main',[_c('Alert'),_c('LoadingOverlay'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }